import styles from "./style.module.scss";
import MessageIcon from "../../../assets/icons/MessageIcon";
import ArrowIcon from "../../../assets/icons/ArrowIcon";

interface VLMessageProps {
  onClick: () => void;
  title: string;
  description: string;
  textButton: string;
}

export default function VLMessage({
  onClick,
  title,
  description,
  textButton,
}: VLMessageProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div>
          <MessageIcon />
        </div>
        <div className={styles.cardContent}>
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <button type="button" className={styles.button} onClick={onClick}>
          {textButton}
          <ArrowIcon />
        </button>
      </div>
    </div>
  );
}
